import React from 'react'
import styled from 'styled-components'
import { InfoTooltip } from '../InfoTooltip'

export const StyledNHInfoPanel = styled.div`
  padding: 0 15px 12px 15px;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 20px;
  @media screen and (max-width: 1024px) {
    padding: 0 5px 15px 5px;
    flex-direction: column;
  }

  & .nh-info-title {
    flex-basis: content;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: start;
    margin-right: 16px;
    .nh-info-desc {
      font-size: 0.85rem;
      font-weight: bold;
      margin-left: 5px;
    }
    @media screen and (max-width: 1024px) {
      margin-bottom: 10px;
    }
  }
  & .nh-info-panels {
    flex-basis: 55%;
    justify-content: space-between;
    display: flex;
    @media screen and (max-width: 1024px) {
      width: calc(100% - 1em);
    }
  }
`

interface StyledPanelProps {
  width: string
}

const StyledDashboardPanel = styled.div<StyledPanelProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  width: ${(props) => props.width};
  padding: 6px;
  & p {
    font-size: 0.765em;
    text-align: left;
    margin-bottom: 0;
    line-height: 20px;
  }
  & div {
    display: flex;
    justify-content: space-between;
  }
`

interface DashboardPanelProps {
  isInteractive?: boolean
  title: string
  value?: string
  width: string
  tooltipText: string
}

export const DashboardPanel: React.FC<DashboardPanelProps> = ({ title, value, width, tooltipText, isInteractive }) => {
  return (
    <StyledDashboardPanel width={width}>
      <p>{title}</p>
      <div className="value-block">
        <strong className="marginRight5">{value || 'NA'}</strong>
        {isInteractive && <InfoTooltip textContent={tooltipText} />}
      </div>
    </StyledDashboardPanel>
  )
}

DashboardPanel.defaultProps = {
  isInteractive: true,
  value: 'NA',
}
